import { combineReducers } from "redux";
import devices from "./devices";
import user from "./user";

export default combineReducers({
  devices,
  user,
});
